module.exports = __webpack_public_path__ + "img/vertical_6_2_3.b34bb6ab.png";